import { CHANGE_LANGUAGE, CHANGE_COUNTRY } from '../actionsList';
import { changeBodyDirection } from '../../utils/useful'
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export function ChangeLanguage(state, action) {
    let language = action.value
    if (language) {
        changeBodyDirection(language)
    }
}

const settings = store => next => action => {
    let result = next(action)
    if (action.type === CHANGE_LANGUAGE) {
        ChangeLanguage(store.getState(), action)
    }
    if (action.type === CHANGE_COUNTRY) {
        ChangeCountry(store.getState(), action)
    }
    return result
}
export function ChangeCountry(state, action) {
    console.log('ChangeCountry actionnnnnnn')
    // console.log(action)

    cookies.set('country', action?.value?._id, { path: '/' })
}
export default settings;